import { render, staticRenderFns } from "./BlogSavedCard.vue?vue&type=template&id=0c84a3be"
import script from "./BlogSavedCard.vue?vue&type=script&lang=js"
export * from "./BlogSavedCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports